import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 px-4 bg-navy-light" data-id="element-103">
      <div className="max-w-4xl mx-auto text-center" data-id="element-104">
        <motion.h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-8 leading-tight" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-105">
          El problema no es tu motivación…{' '}
          <span className="text-accent" data-id="element-106">es que nunca tuviste un sistema</span>
        </motion.h2>

        <motion.div className="text-xl md:text-2xl text-gray-300 leading-relaxed space-y-6" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-107">
          <p data-id="element-108">
            Cada vez que intentaste correr, empezaste con toda la energía del
            mundo.
          </p>
          <p data-id="element-109">
            Pero a los pocos días, llegó la{' '}
            <span className="text-accent font-bold" data-id="element-110">frustración</span>. Te
            cansabas demasiado rápido. No veías progreso. Y terminabas{' '}
            <span className="text-accent font-bold" data-id="element-111">abandonando</span> otra vez.
          </p>
          <p data-id="element-112">
            No es tu culpa. Simplemente nunca tuviste un plan progresivo que te
            llevara{' '}
            <span className="text-white font-semibold" data-id="element-113">paso a paso</span>, sin
            depender de la motivación.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-white mt-8" data-id="element-114">
            Hasta ahora.
          </p>
        </motion.div>
      </div>
    </section>;
}